import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Cart Store
export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      discountCode: null,
      discountAmount: 0,
      
      addItem: (item) => {
        const items = get().items;
        const existingItem = items.find((i) => i.id === item.id);
        
        if (existingItem) {
          set({
            items: items.map((i) =>
              i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
            ),
          });
        } else {
          // Preserve the available stock from the product before setting cart quantity to 1
          const availableStock = item.quantity || 0;
          set({ items: [...items, { ...item, quantity: 1, available_stock: availableStock }] });
        }
      },
      
      removeItem: (id) => {
        set({ items: get().items.filter((i) => i.id !== id) });
      },
      
      updateQuantity: (id, quantity) => {
        if (quantity <= 0) {
          get().removeItem(id);
          return;
        }
        set({
          items: get().items.map((i) =>
            i.id === id ? { ...i, quantity } : i
          ),
        });
      },
      
      applyDiscount: (code, percentage) => {
        const subtotal = get().getSubtotal();
        const discount = (subtotal * percentage) / 100;
        set({ discountCode: code, discountAmount: discount });
      },
      
      removeDiscount: () => {
        set({ discountCode: null, discountAmount: 0 });
      },
      
      clearCart: () => set({ items: [], discountCode: null, discountAmount: 0 }),
      
      getSubtotal: () => {
        return get().items.reduce(
          (total, item) => total + item.selling_rate * item.quantity,
          0
        );
      },
      
      getTotal: () => {
        return get().getSubtotal() - get().discountAmount;
      },
      
      getItemCount: () => {
        return get().items.reduce((count, item) => count + item.quantity, 0);
      },
    }),
    {
      name: 'cart-storage',
    }
  )
);

// Recently Viewed Store
export const useRecentlyViewedStore = create(
  persist(
    (set, get) => ({
      items: [],
      
      addItem: (item) => {
        const items = get().items.filter(i => i.id !== item.id);
        set({ items: [item, ...items].slice(0, 5) }); // Keep last 5
      },
      
      clearItems: () => set({ items: [] }),
    }),
    {
      name: 'recently-viewed-storage',
    }
  )
);

// Auth Store
export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      
      login: (user, token) => {
        localStorage.setItem('token', token);
        set({ user, token, isAuthenticated: true });
      },
      
      logout: () => {
        localStorage.removeItem('token');
        set({ user: null, token: null, isAuthenticated: false });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);

// Discount Codes (can be managed via admin in future)
export const DISCOUNT_CODES = {
  'WELCOME10': { percentage: 10, description: '10% off for new customers' },
  'SAVE15': { percentage: 15, description: '15% off on orders above ₹2000' },
  'FESTIVE20': { percentage: 20, description: '20% festive season discount' },
  'BULK25': { percentage: 25, description: '25% off on bulk orders' },
};
